// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { GetAssignmentsGetFromOpenClaimcasesData, GetAssignmentsGetFromOpenClaimcasesResponses, GetAutoCreateEmailTemplatesListData, GetAutoCreateEmailTemplatesListResponses, GetEmailTemplatesListData, GetEmailTemplatesListResponses, GetEmailTemplatesListSpecialData, GetEmailTemplatesListSpecialResponses, GetFnolTemplatesListData, GetFnolTemplatesListResponses, GetListPartnersData, GetListPartnersResponses, GetOauthCallbackByIntegrationData, GetOauthCallbackByIntegrationErrors, GetOauthCallbackByIntegrationResponses, GetPaymentsGetFromOpenClaimcasesData, GetPaymentsGetFromOpenClaimcasesResponses, GetPaymentsGetRejectedData, GetPaymentsGetRejectedResponses, GetPaymentsGetScheduledData, GetPaymentsGetScheduledResponses, GetPaymentsGetUnsignedData, GetPaymentsGetUnsignedResponses, GetReportsBankTransactionData, GetReportsBankTransactionErrors, GetReportsBankTransactionResponses, GetReportsClaimSummaryData, GetReportsClaimSummaryErrors, GetReportsClaimSummaryResponses, GetReportsFullTransactionData, GetReportsFullTransactionErrors, GetReportsFullTransactionResponses, GetReportsKpiCombinedData, GetReportsKpiCombinedErrors, GetReportsKpiCombinedResponses, GetReportsKpiData, GetReportsKpiErrors, GetReportsKpiListData, GetReportsKpiListResponses, GetReportsKpiResponses, GetReportsScheduledPaymentsData, GetReportsScheduledPaymentsErrors, GetReportsScheduledPaymentsResponses, GetReportsSummaryData, GetReportsSummaryErrors, GetReportsSummaryResponses, GetReportsTransactionData, GetReportsTransactionErrors, GetReportsTransactionResponses, GetSebHealthData, GetSebHealthResponses, PostAutoCreateEmailTemplatesCopyData, PostAutoCreateEmailTemplatesCopyErrors, PostAutoCreateEmailTemplatesCopyResponses, PostAutoCreateEmailTemplatesSyncData, PostAutoCreateEmailTemplatesSyncResponses, PostEmailTemplatesCopyData, PostEmailTemplatesCopyEmailSignatureData, PostEmailTemplatesCopyEmailSignatureErrors, PostEmailTemplatesCopyEmailSignatureResponses, PostEmailTemplatesCopyErrors, PostEmailTemplatesCopyResponses, PostEmailTemplatesSyncData, PostEmailTemplatesSyncResponses, PostExportPaymentsData, PostExportPaymentsErrors, PostExportPaymentsResponses, PostFnolTemplatesCopyData, PostFnolTemplatesCopyErrors, PostFnolTemplatesCopyResponses, PostFnolTemplatesSyncData, PostFnolTemplatesSyncResponses, PostRetryFailedExportsData, PostRetryFailedExportsResponses, PostSyncSebReportsData, PostSyncSebReportsResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const getAssignmentsGetFromOpenClaimcases = <ThrowOnError extends boolean = true>(options?: Options<GetAssignmentsGetFromOpenClaimcasesData, ThrowOnError>) => (options?.client ?? client).get<GetAssignmentsGetFromOpenClaimcasesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assignments/getFromOpenClaimcases',
    ...options
});

export const postAutoCreateEmailTemplatesCopy = <ThrowOnError extends boolean = true>(options?: Options<PostAutoCreateEmailTemplatesCopyData, ThrowOnError>) => (options?.client ?? client).post<PostAutoCreateEmailTemplatesCopyResponses, PostAutoCreateEmailTemplatesCopyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/autoCreateEmailTemplates/copy',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getAutoCreateEmailTemplatesList = <ThrowOnError extends boolean = true>(options?: Options<GetAutoCreateEmailTemplatesListData, ThrowOnError>) => (options?.client ?? client).get<GetAutoCreateEmailTemplatesListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/autoCreateEmailTemplates/list',
    ...options
});

export const postAutoCreateEmailTemplatesSync = <ThrowOnError extends boolean = true>(options?: Options<PostAutoCreateEmailTemplatesSyncData, ThrowOnError>) => (options?.client ?? client).post<PostAutoCreateEmailTemplatesSyncResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/autoCreateEmailTemplates/sync',
    ...options
});

export const postEmailTemplatesCopy = <ThrowOnError extends boolean = true>(options?: Options<PostEmailTemplatesCopyData, ThrowOnError>) => (options?.client ?? client).post<PostEmailTemplatesCopyResponses, PostEmailTemplatesCopyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/emailTemplates/copy',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postEmailTemplatesCopyEmailSignature = <ThrowOnError extends boolean = true>(options?: Options<PostEmailTemplatesCopyEmailSignatureData, ThrowOnError>) => (options?.client ?? client).post<PostEmailTemplatesCopyEmailSignatureResponses, PostEmailTemplatesCopyEmailSignatureErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/emailTemplates/copyEmailSignature',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getEmailTemplatesList = <ThrowOnError extends boolean = true>(options?: Options<GetEmailTemplatesListData, ThrowOnError>) => (options?.client ?? client).get<GetEmailTemplatesListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/emailTemplates/list',
    ...options
});

export const getEmailTemplatesListSpecial = <ThrowOnError extends boolean = true>(options?: Options<GetEmailTemplatesListSpecialData, ThrowOnError>) => (options?.client ?? client).get<GetEmailTemplatesListSpecialResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/emailTemplates/listSpecial',
    ...options
});

export const postEmailTemplatesSync = <ThrowOnError extends boolean = true>(options?: Options<PostEmailTemplatesSyncData, ThrowOnError>) => (options?.client ?? client).post<PostEmailTemplatesSyncResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/emailTemplates/sync',
    ...options
});

export const postExportPayments = <ThrowOnError extends boolean = true>(options?: Options<PostExportPaymentsData, ThrowOnError>) => (options?.client ?? client).post<PostExportPaymentsResponses, PostExportPaymentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/exportPayments',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postFnolTemplatesCopy = <ThrowOnError extends boolean = true>(options?: Options<PostFnolTemplatesCopyData, ThrowOnError>) => (options?.client ?? client).post<PostFnolTemplatesCopyResponses, PostFnolTemplatesCopyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fnolTemplates/copy',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getFnolTemplatesList = <ThrowOnError extends boolean = true>(options?: Options<GetFnolTemplatesListData, ThrowOnError>) => (options?.client ?? client).get<GetFnolTemplatesListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fnolTemplates/list',
    ...options
});

export const postFnolTemplatesSync = <ThrowOnError extends boolean = true>(options?: Options<PostFnolTemplatesSyncData, ThrowOnError>) => (options?.client ?? client).post<PostFnolTemplatesSyncResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fnolTemplates/sync',
    ...options
});

export const getListPartners = <ThrowOnError extends boolean = true>(options?: Options<GetListPartnersData, ThrowOnError>) => (options?.client ?? client).get<GetListPartnersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/listPartners',
    ...options
});

export const getOauthCallbackByIntegration = <ThrowOnError extends boolean = true>(options: Options<GetOauthCallbackByIntegrationData, ThrowOnError>) => (options.client ?? client).get<GetOauthCallbackByIntegrationResponses, GetOauthCallbackByIntegrationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/oauth_callback/{integration}',
    ...options
});

export const getPaymentsGetFromOpenClaimcases = <ThrowOnError extends boolean = true>(options?: Options<GetPaymentsGetFromOpenClaimcasesData, ThrowOnError>) => (options?.client ?? client).get<GetPaymentsGetFromOpenClaimcasesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/payments/getFromOpenClaimcases',
    ...options
});

export const getPaymentsGetRejected = <ThrowOnError extends boolean = true>(options?: Options<GetPaymentsGetRejectedData, ThrowOnError>) => (options?.client ?? client).get<GetPaymentsGetRejectedResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/payments/getRejected',
    ...options
});

export const getPaymentsGetScheduled = <ThrowOnError extends boolean = true>(options?: Options<GetPaymentsGetScheduledData, ThrowOnError>) => (options?.client ?? client).get<GetPaymentsGetScheduledResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/payments/getScheduled',
    ...options
});

export const getPaymentsGetUnsigned = <ThrowOnError extends boolean = true>(options?: Options<GetPaymentsGetUnsignedData, ThrowOnError>) => (options?.client ?? client).get<GetPaymentsGetUnsignedResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/payments/getUnsigned',
    ...options
});

export const getReportsBankTransaction = <ThrowOnError extends boolean = true>(options?: Options<GetReportsBankTransactionData, ThrowOnError>) => (options?.client ?? client).get<GetReportsBankTransactionResponses, GetReportsBankTransactionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reports/bankTransaction',
    ...options
});

export const getReportsClaimSummary = <ThrowOnError extends boolean = true>(options?: Options<GetReportsClaimSummaryData, ThrowOnError>) => (options?.client ?? client).get<GetReportsClaimSummaryResponses, GetReportsClaimSummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reports/claimSummary',
    ...options
});

export const getReportsFullTransaction = <ThrowOnError extends boolean = true>(options: Options<GetReportsFullTransactionData, ThrowOnError>) => (options.client ?? client).get<GetReportsFullTransactionResponses, GetReportsFullTransactionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reports/fullTransaction',
    ...options
});

export const getReportsKpi = <ThrowOnError extends boolean = true>(options: Options<GetReportsKpiData, ThrowOnError>) => (options.client ?? client).get<GetReportsKpiResponses, GetReportsKpiErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reports/kpi',
    ...options
});

export const getReportsKpiCombined = <ThrowOnError extends boolean = true>(options: Options<GetReportsKpiCombinedData, ThrowOnError>) => (options.client ?? client).get<GetReportsKpiCombinedResponses, GetReportsKpiCombinedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reports/kpiCombined',
    ...options
});

export const getReportsKpiList = <ThrowOnError extends boolean = true>(options?: Options<GetReportsKpiListData, ThrowOnError>) => (options?.client ?? client).get<GetReportsKpiListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reports/kpiList',
    ...options
});

export const getReportsScheduledPayments = <ThrowOnError extends boolean = true>(options?: Options<GetReportsScheduledPaymentsData, ThrowOnError>) => (options?.client ?? client).get<GetReportsScheduledPaymentsResponses, GetReportsScheduledPaymentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reports/scheduledPayments',
    ...options
});

export const getReportsSummary = <ThrowOnError extends boolean = true>(options?: Options<GetReportsSummaryData, ThrowOnError>) => (options?.client ?? client).get<GetReportsSummaryResponses, GetReportsSummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reports/summary',
    ...options
});

export const getReportsTransaction = <ThrowOnError extends boolean = true>(options: Options<GetReportsTransactionData, ThrowOnError>) => (options.client ?? client).get<GetReportsTransactionResponses, GetReportsTransactionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reports/transaction',
    ...options
});

export const postRetryFailedExports = <ThrowOnError extends boolean = true>(options?: Options<PostRetryFailedExportsData, ThrowOnError>) => (options?.client ?? client).post<PostRetryFailedExportsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/retryFailedExports',
    ...options
});

export const getSebHealth = <ThrowOnError extends boolean = true>(options?: Options<GetSebHealthData, ThrowOnError>) => (options?.client ?? client).get<GetSebHealthResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sebHealth',
    ...options
});

export const postSyncSebReports = <ThrowOnError extends boolean = true>(options?: Options<PostSyncSebReportsData, ThrowOnError>) => (options?.client ?? client).post<PostSyncSebReportsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/syncSebReports',
    ...options
});
